import { empty } from "core/utils";
import { deleteJson, postJson } from "core/utils/http";

export type Credentials = { segment: string; username: string; code: string; };

export type ECommerceConfiguration = { mode: string; scriptResources: string[]; };

type AuthenticationResult = { isAuthenticated: boolean; username: string; eCommerceConfiguration: ECommerceConfiguration; };

type DatosSesion = { autenticado: boolean; usuario: string; configuracionLigaPagos: ECommerceConfiguration };

export default abstract class AuthenticationProvider {
	static signin = ({ segment, username, code }: Credentials): Promise<AuthenticationResult> =>
		postJson<DatosSesion>("/api/Sesion", { segmentoRuteo: segment, usuario: username, clave: code })
			.then((resultado) => ({
				isAuthenticated: resultado.autenticado,
				username: resultado.usuario,
				eCommerceConfiguration: resultado.configuracionLigaPagos
			}));

	static signout = (): Promise<void> =>
		deleteJson("/api/Sesion")
			.catch(empty);
}